import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthProvider } from "@cloudpremise/portal_core";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import MDTypography from "@cloudpremise/portal_core/src/themes/mui/components/MDTypography";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";
import MDInput from "@cloudpremise/portal_core/src/themes/mui/components/MDInput";
import MDButton from "@cloudpremise/portal_core/src/themes/mui/components/MDButton";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

const DeployedSites = (props) => {
    const [ authorized, authType, token ] = useAuthProvider();
    const [ controller ] = useMaterialUIController();
    const { config, user } = controller;
    const defaultState = {
        maintenanceMode: false,
        maintenanceImageUrl: "",
        maintenanceMessage: "",
        allowBypass: false,
        banner: false,
        bannerText: "We are performing scheduled maintenance on 01/25/2024. We should be back online shortly after the maintenance.",
        bannerColor: "#FFAB00",
        textColor: "#000000",
        bannerCanClose: true,
        bannerTimeOn: "2025-01-20 11:58:00",
        bannerTimeOff: "2025-01-22 11:58:00",
        allowBundleDomain: true,
        proteusLeadObject: "sfLead",
    }
    const [state, setState] = React.useReducer((state: any, newState: Partial<any>) => ({
        ...state,
        ...newState
    }), defaultState);
    const navigate = useNavigate();
    React.useEffect(() => {
        if(!authorized){
            return navigate("/landing", { replace: true });
        }
    });

    function handleChange(e, name){
        setState({
            ...state,
            [name]: e.target.value,
        });
    }
    function handleCheckbox(e, name){
        setState({
            ...state,
            [name]: e.target.checked,
        });
    }
    if(!authorized || !user.superAdmin){
        return null;
    }
    return (
        <MDBox>
            <Card>
                <MDBox p={2}>
                    <MDBox
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                        mb={2}
                    >
                        <MDTypography component="h5" variant="h5" fontWeight="bold" color="dark">
                            Deployed Sites
                        </MDTypography>
                        <MDButton variant="contained" color="dark">
                            Add New Site
                        </MDButton>
                    </MDBox>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        site1.olympus-grid.com
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="success" size="small">
                                            Active
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        alpha.olympus-grid.com
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="warning" size="small">
                                            Maintenance
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        beta.olympus-grid.com
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="error" size="small">
                                            Disabled
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        clientx.grid.io
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="success" size="small">
                                            Active
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        demo.olympus.io
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="info" size="small">
                                            Testing
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        web1.grid.io
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="success" size="small">
                                            Active
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        mainnet.olympus-grid.com
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="purple" size="small">
                                            Staging
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        uat.grid.dev
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="success" size="small">
                                            Active
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        vip.olympus-grid.net
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="error" size="small">
                                            Disabled
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={6} lg={4}>
                            <Card>
                                <MDBox p={2}>
                                    <MDTypography variant="button" fontWeight="light" color="dark">
                                        secure.olympus.app
                                    </MDTypography>
                                    <MDBox mt={1}>
                                        <MDButton variant="contained" color="success" size="small">
                                            Active
                                        </MDButton>
                                        <MDButton variant="contained" color="dark" sx={{marginLeft: "10px"}} size="small">
                                            Manage
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
            </Card>
        </MDBox>
    )
}

export default DeployedSites;